import { render, staticRenderFns } from "./ResendReasonByFilter.vue?vue&type=template&id=b70e2b80&"
import script from "./ResendReasonByFilter.vue?vue&type=script&lang=js&"
export * from "./ResendReasonByFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports